import { render, staticRenderFns } from "./FooterHead.vue?vue&type=template&id=4ab8efa7&"
import script from "./FooterHead.vue?vue&type=script&lang=js&"
export * from "./FooterHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports